import React, { createContext, useContext, useState, useEffect } from 'react';
import { useStructure } from './StructureContext';
import { getPeople } from '../api';

const PersonContext = createContext();

export function PersonProvider({ children, userName }) {
  const { currentStructure } = useStructure();
  const [people, setPeople] = useState([]);
  const [currentPerson, setCurrentPersonState] = useState(null);

  useEffect(() => {
    if (!currentStructure) return;

    getPeople(currentStructure.id)
      .then(res => {
        const fetchedPeople = res.data;
        setPeople(fetchedPeople);

        // 1. Restaurer depuis localStorage
        const savedId = localStorage.getItem(`selectedPerson_${currentStructure.id}`);
        if (savedId) {
          const saved = fetchedPeople.find(p => p.id === savedId);
          if (saved) {
            setCurrentPersonState(saved);
            return;
          }
        }

        // 2. Matcher avec le nom du compte connecté (ex: "Nicolas Dupont")
        if (userName) {
          const normalizedUser = userName.toLowerCase().trim();
          const matched = fetchedPeople.find(p => {
            const fullName = `${p.firstName} ${p.lastName}`.toLowerCase();
            const reverseName = `${p.lastName} ${p.firstName}`.toLowerCase();
            return fullName === normalizedUser || reverseName === normalizedUser;
          });
          if (matched) {
            setCurrentPersonState(matched);
            return;
          }
        }

        // 3. Sinon prendre la première personne
        setCurrentPersonState(fetchedPeople[0] || null);
      })
      .catch(() => {});
  }, [currentStructure, userName]);

  const setCurrentPerson = (person) => {
    setCurrentPersonState(person);
    if (person && currentStructure) {
      localStorage.setItem(`selectedPerson_${currentStructure.id}`, person.id);
    }
  };

  return (
    <PersonContext.Provider value={{ people, currentPerson, setCurrentPerson }}>
      {children}
    </PersonContext.Provider>
  );
}

export function usePersonContext() {
  const context = useContext(PersonContext);
  if (!context) throw new Error('usePersonContext must be used within a PersonProvider');
  return context;
}
